import Vue from 'vue'
import Router from 'vue-router'
//import HelloWorld from '@/components/HelloWorld'
import IndexPage from '../components/index'
import VipIndexPage from '../components/vip'
import commonSec from '../components/commonSec'
import problemDetail from '../components/problemDetail'
import service from '../components/service'
import selfPush from '../components/selfPush'
import selfCheck from '../components/selfCheck'
import hotMap from '../components/hotMap'
import orderForm from '../components/orderForm'
import rgfw from '../components/rgfw'

Vue.use(Router)

export default new Router({
  //mode: 'history',
  routes: [
    {
      path: '/',
      name: 'IndexPage',
     
      component: IndexPage
    },
    {
      path: '/vip',
      name: 'VipIndexPage',
     
      component: VipIndexPage
    },
    {
      path: '/commonSec',
      name: 'commonSec',     
      component: commonSec,
      children:[
      	
      ]
    },
    {
	      path: '/commonSec/problemDetail',
	      name: '/commonSec/problemDetail',
	     
	      component: problemDetail
	 },

	 {
	      path: '/service',
	      name: 'service',
	     
	      component: service
	},
	{
	      path: '/selfPush',
	      name: 'selfPush',
	     
	      component: selfPush
	},
	{
	      path: '/hotMap',
	      name: 'hotMap',
	     
	      component: hotMap
	},

	{
	      path: '/selfCheck',
	      name: 'selfCheck',
	     
	      component: selfCheck
	},
	{
	      path: '/orderForm',
	      name: 'orderForm',
	     
	      component: orderForm
	},
	{
	      path: '/rgfw',
	      name: 'rgfw',
	     
	      component: rgfw
	}


    
   
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js